// I had to use a mixin instead of a service because services do not have access to the Vue instance ($vuetify) and also
// they aren't reactive, so computed properties depending on them wouldn't update the UI when the breakpoint changes.
export default {
  computed: {
    isMobilePortrait() {
      return this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width;
    },
    isMobileLandscape() {
      return this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width >= this.$vuetify.breakpoint.height;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isPortrait() {
      return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width;
    }
  }
};
